import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import quickLinks from '../../defaultData/quickLinks';
import * as actionCreators from '../../actions';
import Tabs from '../Tabs';
import TabPane from '../Tabs/TabPane';
import SearchCard from '../Search/SearchCard';
import useToggle from '../../hooks/useToggle';
import TabPlaceholder from '../Placeholders/TabPlaceholder';

const RentTab = dynamic(() => import('./RentTab'), {
  loading: TabPlaceholder,
  ssr: false
});

const SearchTab = dynamic(() => import('./SearchTab'), {
  loading: TabPlaceholder,
  ssr: false
});

const mapStateToProps = state => state.searchForm;

const TopTabs = ({ switchTab, currentTabId, defaultState, currentState }) => {
  const { t } = useTranslation();
  const quickLinksData = quickLinks(t);
  const [isFiltersPopupOpen, togglePopup] = useToggle(false);
  const [image, setImage] = useState();
  const titles = {
    sell: {
      name: 'sell',
      label: t('top_tabs.titles.sell')
    },
    rent: {
      name: 'rent',
      label: t('top_tabs.titles.rent')
    },
    search: {
      name: 'search',
      label: t('top_tabs.titles.search')
    }
  };

  const isRetina = () => {
    if (typeof window !== 'undefined') {
      return (
        (window.matchMedia &&
          (window.matchMedia(
            'only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)'
          ).matches ||
            window.matchMedia(
              'only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)'
            ).matches)) ||
        (window.devicePixelRatio && window.devicePixelRatio >= 2)
      );
    }
  };

  useEffect(() => {
    const imageSize = isRetina() ? 'retina' : 'normal';
    setImage(imageSize);
  });

  return (
    <Tabs
      selected={currentTabId}
      switchTab={switchTab}
      scopeClass="quick-links"
      titles={Object.values(titles)}
    >
      <TabPane name="sell" additionalClasses="tabs__content_pane--scrollable">
        <div className="search-card-list">
          <SearchCard
            title={t('quick_links.new')}
            id="search-card-new"
            titleUrl="/menziller/yeni-tikili"
            data={quickLinksData.new}
            slug="baki/alqi-satqi"
            backgroundImageUrl={
              image
                ? `url('/static/images/search/quick-links/${image}/buy-new.jpg')`
                : null
            }
          />
          <SearchCard
            title={t('quick_links.secondary')}
            id="search-card-secondary"
            titleUrl="/menziller/kohne-tikili"
            data={quickLinksData.secondary}
            slug="baki/alqi-satqi"
            backgroundImageUrl={
              image
                ? `url('/static/images/search/quick-links/${image}/buy-secondary.jpg')`
                : null
            }
          />
          <SearchCard
            title={t('quick_links.estate')}
            id="search-card-estate"
            data={quickLinksData.estate}
            slug="baki/alqi-satqi"
            backgroundImageUrl={
              image
                ? `url('/static/images/search/quick-links/${image}/buy-estate.jpg')`
                : null
            }
          />
        </div>
      </TabPane>
      <TabPane
        name={titles.rent.name}
        additionalClasses="tabs__content_pane--scrollable"
      >
        <RentTab {...{ quickLinksData, image }} />
      </TabPane>
      <TabPane name={titles.search.name}>
        <SearchTab
          {...{ isFiltersPopupOpen, togglePopup, defaultState, currentState }}
        />
      </TabPane>
    </Tabs>
  );
};

TopTabs.propTypes = {
  currentTabId: PropTypes.number,
  switchTab: PropTypes.func,
  togglePopup: PropTypes.func,
  setInitialFiltersValues: PropTypes.object,
  defaultState: PropTypes.object,
  currentState: PropTypes.object
};

export default connect(mapStateToProps, actionCreators)(TopTabs);
